import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../../hooks'
import {
  getItemsIds,
  getMassActionExcludeIdParam,
  getMassActionIdParam,
} from '../../../../../utils/common'
import { stopPropagation } from '../../../../../utils/events'
import { getMassActionsSuccessItemsLength } from '../../../../../utils/massActions'
import { EMAIL_ITEM_ID_KEY } from '../../../../Email'
import { performRequestThreadsMassAction } from '../../RequestProfileTabEmails.api'
import {
  REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION,
  REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION_NAMES,
} from '../../RequestProfileTabEmails.constants'
import { isRequestProfileTabEmailsMassActionDelete } from '../../RequestProfileTabEmails.utils'

import {
  getRequestProfileTabEmailsMassActionsErrorTitleKey,
  getRequestProfileTabEmailsMassActionsNotificationTitleKey,
} from './useRequestProfileTabEmailsMassActions.utils'

export function useRequestProfileTabEmailsMassActions({
  exclude,
  filterValues,
  requestId,
  selectAllPages,
  selected,
  setPerformingAction,
  showDeleteConfirmModal,
  onCleanSelection,
  onCloseModal,
  onReload,
}) {
  const { t } = useTranslation()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  function handleMassAction(action) {
    const uuids = getMassActionIdParam({
      ids: getItemsIds(selected, EMAIL_ITEM_ID_KEY),
      selectAllPages,
    })
    const excludeUuids = getMassActionExcludeIdParam({
      excludeIds: getItemsIds(exclude, EMAIL_ITEM_ID_KEY),
      selectAllPages,
    })

    setPerformingAction(true)

    return performRequestThreadsMassAction({
      data: {
        action: REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION_NAMES[action],
        all: selectAllPages,
        filters: {
          ...filterValues,
          exclude_uuid: excludeUuids,
          uuid: uuids,
        },
      },
      requestId,
    })
      .then(({ data }) => {
        const successCount = getMassActionsSuccessItemsLength(data) ?? 0
        const totalCount = data?.items?.length ?? 0

        if (successCount === 0) {
          handleAddErrorNotification(
            getRequestProfileTabEmailsMassActionsErrorTitleKey(action)
          )
        } else {
          handleAddSuccessNotification({
            title: t(
              getRequestProfileTabEmailsMassActionsNotificationTitleKey(action),
              { count: successCount, totalCount }
            ),
          })
        }

        onCleanSelection?.()

        return onReload()
      })
      .catch(() =>
        handleAddErrorNotification(
          getRequestProfileTabEmailsMassActionsErrorTitleKey(action)
        )
      )
      .finally(() => setPerformingAction(false))
  }

  function handleSubmitMassActionDelete(e) {
    stopPropagation(e)
    onCloseModal()

    return handleMassAction(REQUEST_PROFILE_TAB_EMAILS_MASS_ACTION.Delete)
  }

  function setMassAction(action) {
    if (isRequestProfileTabEmailsMassActionDelete(action)) {
      showDeleteConfirmModal({ onSubmit: handleSubmitMassActionDelete })

      return
    }

    handleMassAction(action)
  }

  return {
    setMassAction,
  }
}
